// extracted by mini-css-extract-plugin
export var quantityInput = "_gq-0";